import { render, staticRenderFns } from "./PanelVideo.vue?vue&type=template&id=6defd34c&scoped=true&"
import script from "./PanelVideo.vue?vue&type=script&lang=js&"
export * from "./PanelVideo.vue?vue&type=script&lang=js&"
import style0 from "./PanelVideo.vue?vue&type=style&index=0&id=6defd34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6defd34c",
  null
  
)

export default component.exports